import React from 'react';
import { Card, Typography } from 'antd';
import { useFileViewer, FileEmptyState, getFileTypeFromUrl } from './FileViewer';
import { PDFViewer } from './PDFViewer';
import { XMLViewer } from './XMLViewer';

// Unsupported file type component
const UnsupportedFileViewer: React.FC<{ fileUrl: string; fileType: string }> = ({
  fileUrl,
  fileType
}) => (
  <Card>
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <Typography.Title level={4} type="warning">
        Unsupported File Type
      </Typography.Title>
      <Typography.Text>
        Files with extension "{fileType}" are not currently supported for viewing.
      </Typography.Text>
      <br />
      <Typography.Text type="secondary">
        You can still download the file using the link below.
      </Typography.Text>
      <br />
      <br />
      <Typography.Link href={fileUrl} target="_blank" download>
        Download {fileUrl.split('/').pop() || 'file'}
      </Typography.Link>
    </div>
  </Card>
);

// Main file viewer component
export const FileViewerMain: React.FC = () => {
  const { fileUrl, fileType } = useFileViewer();

  // No file selected
  if (!fileUrl) {
    return <FileEmptyState message="No file selected for viewing" />;
  }

  // Determine file type if not already set
  const detectedFileType = fileType || getFileTypeFromUrl(fileUrl);

  // Render appropriate viewer based on file type
  const renderViewer = () => {
    switch (detectedFileType) {
      case 'pdf':
        return <PDFViewer fileUrl={fileUrl} />;

      case 'xml':
        return <XMLViewer fileUrl={fileUrl} />;

      default:
        return (
          <UnsupportedFileViewer
            fileUrl={fileUrl}
            fileType={detectedFileType}
          />
        );
    }
  };

  // Wrap in a full-height container
  return (
    <div style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      {renderViewer()}
    </div>
  );
};

// Named export for the complete file viewer system
export const FileViewer = FileViewerMain;
